import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// LiteCollectionData — shown when LiteCollection is selected (and not CustomGlassCutoutOptions)
// Options are static placeholders; in a DB-driven version these would be fetched
const OPTIONS_BY_COLLECTION = {
  decorativeglass:          ['A', 'B', 'C', 'D'],
  texturedglass:            ['P516', 'P518', 'P520'],
  wroughtiron:              ['W101', 'W102', 'W103'],
  commodityglass:           ['CG-1', 'CG-2', 'CG-3'],
};

const LiteCollectionData = ({
  value = { value: '', label: '' },
  onChange,
  disabled = false,
  liteCollection,
}) => {
  const [selected, setSelected] = useState(value?.value || '');

  // Reset when collection changes
  useEffect(() => {
    setSelected('');
    onChange({ value: '', label: '' });
  }, [liteCollection?.value]);

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const options = OPTIONS_BY_COLLECTION[liteCollection?.value] || [];

  const handleChange = (e) => {
    const v = e.target.value;
    setSelected(v);
    onChange({ value: v, label: v });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdLiteCollectionData">Lite Collection Data</label>
      <select id="SdLiteCollectionData" value={selected} onChange={handleChange} disabled={disabled}>
        {options.map(o => (
          <option key={o} value={o}>
            {selected === o ? `${o} ✔` : o}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LiteCollectionData;
